import axios from 'axios';
import Constants from '../constants';
import { ICulture } from '../models';

export async function getCultures(): Promise<ICulture[]> {
	try {
		const res = await axios.get(Constants.API_CULTURES_URL);
		if (res.status === 200) {
			return res.data;
		}
	} catch (Error) {
		/*generic error*/
	}
	throw Error('An error occurred trying to fetch cultures');
}
